module.exports = __webpack_public_path__ + "static/assets/f015398b5cd5c1d5157615fe3309e039.svg";